import React from "react";
import {
  Route,
  withRouter,
} from "react-router-dom";
import classnames from "classnames";

// styles
import useStyles from "../styles";

// components
import Header from "../../Header/Header";
import Sidebar from "../../Sidebar/Sidebar";

// pages
import Dashboard from "../../../pages/dashboard/Dashboard";
import ReportByPublisher from "../../../pages/reportByPublisher";

// context
import { useLayoutState } from "../../../context/LayoutContext";

function LayoutSales(props) {
  var classes = useStyles();

  // global
  var layoutState = useLayoutState();

  return (
    <div className={classes.root}>
        <>
          <Header history={props.history} />
          <Sidebar />
          <div
            className={classnames(classes.content, {
              [classes.contentShift]: layoutState.isSidebarOpened,
            })}
          >
            <div className={classes.fakeToolbar} />
              <Route path="/dashboard" component={Dashboard} />
              <Route path="/reportByPublisher" component={ReportByPublisher} />
          </div>
        </>
    </div>
  );
}

export default withRouter(LayoutSales);
